<template>
    <img :src="getPath(path)" :alt="alt"/>
</template>

<script>
    /* Mixins */
    import { Default } from '../../../mixins/Default'

    /* Logic */
    export default {
        name: "Photo",
        mixins: [Default],
        props: [
            'id',
            'currency',
            'origin',
            'locality',
            'snippets',
            'translatable'
        ],
        data: function () {
            return {
                path: '',
                content: '',
                translations: '',
                alt: ''
            }
        },
        methods: {
            fetchItems: function (id) {
                let item = this.Underscore.findWhere(this.$store.state.photos, { id: id })
                switch (item) {
                    case undefined:
                        this.path = 'app/images/static/placeholder.jpg'
                        this.content = ''
                        this.translations = ''
                        this.alt = ''
                        break
                    default:
                        this.path = item.path
                        this.content = item.content
                        this.translations = item.translations
                        if (this.translations !== null && this.translations.hasOwnProperty(this.locality)) {
                            this.alt = this.translations[this.locality].alt
                        } else {
                            switch (this.origin) {
                                case undefined:
                                    this.alt = this.getSnippets('Company')
                                    break
                                default:
                                    this.alt = this.origin.translations[this.locality].title
                            }
                        }
                }
            }
        },
        created: function () {
            this.initialize()
            this.fetchItems(this.id)
        },
        watch: {
            id: function () {
                this.initialize()
                this.fetchItems(this.id)
            }
        }
    }
</script>
